export default "__VITE_ASSET___7$M0iK$__"